import { indexBy } from "@greeter/map";
import { useMemo } from "react";

export function useIndexBy<T, TKey>(
  arr: Array<T>,
  by: (input: T) => TKey
): Map<TKey, T> {
  return useMemo(() => indexBy(arr, by), [arr]);
}
